export default "__VITE_ASSET__89d2b3ad__"